/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.academy.assistant.rpc.ChatRpc
 */

export const retrieveAuthTokenRpc = {
  serviceName: 'com.hubspot.academy.assistant.rpc.ChatRpc',
  rpcName: 'retrieveAuthToken',
  auth: 'app',
  fingerprint: 'axzdYPrx6b6aVmFV3T9qIFpROKU44M5j',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};